<h1 class="title">Organisation Profile</h1>
<h5>Manage organisation users and subscriptions</h5>
<input #imgBrowser type="file" style="position: fixed; top: -100em" accept="image/*" (change)="organisationLogoChangeHandler($event)">

<ng-container *ngIf="currentOrganisation">
    <div class="cas-flex-row push-up-2 cas-pad organisation-details-wrapper">
        <div class="org-logo-img-container">
            <img *ngIf="!isUploadingLogo" id="org-logo-img" alt="{{currentOrganisation.name}} logo" src="{{currentOrganisation.logoUrl}}">
            <p-progressSpinner *ngIf="isUploadingLogo" [style]="{width: '25px', height: '25px'}" strokeWidth="5" fill="#EEEEEE"
                               animationDuration=".5s"></p-progressSpinner>
            <div class="org-logo-img-change">
                <button (click)="requestToChangeLogo()" class="cas-button-small">Change</button>
            </div>
        </div>
        <div class="cas-flex-column">
            <div class="cas-flex-row org-name-container">
                <ng-container *ngIf="!orgNameEditMode; else orgEdit">
                    <h3>{{currentOrganisation.name}}</h3>
                    <button pButton pRipple type="button" icon="pi pi-pencil"
                            class="p-button-rounded p-button-secondary p-button-outlined edit-button"
                            (click)="orgNameEditMode = true"></button>
                </ng-container>
                <ng-template #orgEdit>
                    <input #orgNameEdit class="org-name-edit" type="text" pInputText name="org-name-edit" value="{{currentOrganisation?.name}}">
                    <button pButton pRipple type="button" icon="pi pi-check" class="p-button-rounded p-button-success p-button-outlined save-button"
                            (click)="onOrganisationNameChanged(orgNameEdit.value)"></button>
                </ng-template>
            </div>
            <span class="p-tag p-tag-rounded p-tag-success">active</span>
        </div>
    </div>
    <p-tabView orientation="right">
        <p-tabPanel header="Users">
            <ng-template pTemplate="content">
                <acabim-admin-organisation-users (userDetailsChanged)="seatView?.onRequestToRefreshData()"></acabim-admin-organisation-users>
            </ng-template>
        </p-tabPanel>
        <p-tabPanel header="Subscription Seats">
            <ng-template pTemplate="content">
                <acabim-admin-organisation-seats #seatsView></acabim-admin-organisation-seats>
            </ng-template>
        </p-tabPanel>
        <p-tabPanel header="Pending Users">
            <ng-template pTemplate="content">
                <acabim-admin-organisation-pending-users></acabim-admin-organisation-pending-users>
            </ng-template>
        </p-tabPanel>
    </p-tabView>
</ng-container>

<ng-template #loading>
    <acabim-loading-view></acabim-loading-view>
</ng-template>
